



























































import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { emailRule, noNumberRule, phoneRule } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { IContact } from "@/models/User/IContact";
import { IUser } from "@/models/User/IUser";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportFormPersonalDataAlt extends ReportStepMixin implements IReportStep {
  public md = 4;
  public static screenName = ReportScreenEnum.contactdetails;
  public header: IReportHeaderData = {
    title: "report.formPersonalData.title",
    description: "report.formPersonalData.description"
  };

  screen = ReportScreenEnum.contactalt;

  phone: any;

  valid = false;

  get isDone() {
    return this.valid;
  }

  get user(): IUser {
    return ReportModule.user;
  }

  set user(user: IUser) {
    ReportModule.setUser(user);
  }

  get companyName(): string {
    return ReportModule.companyName;
  }

  set companyName(companyName: string) {
    ReportModule.setCompanyName(companyName);
  }

  get contact(): IContact {
    return ReportModule.contact;
  }

  set contact(contact: IContact) {
    ReportModule.setContact(contact);
  }

  get noNumberRule() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(noNumberRule());

    return rules;
  }

  get emailRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(emailRule());

    return rules;
  }

  get phoneNumberRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(phoneRule());

    return rules;
  }
}
